import { supabaseClient } from './client';

export const sessionService = {
  getSession: async () => (await supabaseClient.auth.getSession()).data.session || null,
  onAuthStateChange: (cb) => supabaseClient.auth.onAuthStateChange((_event, session) => cb(session)),
  setSession: async (tokens) => (await supabaseClient.auth.setSession(tokens)).data.session || null,
  signOut: async () => supabaseClient.auth.signOut(),
  refresh: async () => (await supabaseClient.auth.refreshSession()).data.session || null,
};

export async function getStatus() {
  const session = await sessionService.getSession();
  
  if (!session) {
    return {
      isExpired: true,
      needsRefresh: false,
      isExpiringSoon: false,
      remainingTime: 0,
      expiryTime: null,
    };
  }
  
  // For testing: if no expires_at, assume 1 minute from now
  let expiresAtSec = session.expires_at;
  if (!expiresAtSec) {
    // Set expiry to 1 minute from now for testing
    expiresAtSec = Math.floor(Date.now() / 1000) + 60;
  }
  
  const expiryMs = expiresAtSec * 1000;
  const now = Date.now();
  const remaining = Math.max(0, Math.floor((expiryMs - now) / 1000));
  const refreshThresholdSec = 30; // 30 seconds (for 1 minute session)
  const warningThresholdSec = 15; // 15 seconds (for 1 minute session)
  
  const status = {
    isExpired: now >= expiryMs,
    needsRefresh: remaining <= refreshThresholdSec,
    isExpiringSoon: remaining > 0 && remaining <= warningThresholdSec,
    remainingTime: remaining,
    expiryTime: expiryMs,
  };
  
  return status;
}


